<script>
import ResourceDetail from '@shell/components/ResourceDetail';

export default {
  name:       'ClusterResourceCreate',
  components: { ResourceDetail },
};
</script>

<template>
  <ResourceDetail component-testid="cluster-manager-create" />
</template>
